import { onClickAll } from './htmlListeners.js';
import { pageRoutes, redirectToPage } from './page-routes.js';
import iconAddSelfie from '../img/icons/menu-add-selfie.svg';
import iconHelp from '../img/icons/menu-help.svg';

(function initMenu() {
  const $menu = document.querySelector('.menu');
  const $menuList = document.querySelector('.menu__list');
  const $btnOpen = document.querySelector('.top-panel__button-menu');
  const $btnClose = document.querySelector('.menu__btn-close');

  const menuList = [
    {
      text: 'Registered Faces',
      icon: iconAddSelfie,
      isHidden: false,
      htmlId: 'selfies',
      href: pageRoutes.selfies,
    },
    {
      text: 'Terms and Conditions',
      icon: iconHelp,
      isHidden: true,
      htmlId: 'privacy-link',
      href: pageRoutes.privacyPolicy,
    },
    {
      text: 'FAQ',
      icon: iconHelp,
      isHidden: false,
      href: pageRoutes.faq,
    },
    {
      text: 'Support',
      icon: iconHelp,
      isHidden: true,
      htmlClass: 'open-zendesk',
    },
  ];

  if ($btnOpen && $btnClose) {
    $btnOpen.addEventListener('click', () => {
      $menu.classList.remove('menu_hidden');
    });

    $btnClose.addEventListener('click', () => {
      $menu.classList.add('menu_hidden');
    });
  }

  if ($menu) {
    const template = menuList.map(({ text, icon, isHidden, href, htmlId, htmlClass }) => {
      const classHidden = isHidden ? 'menu__item_hidden' : '';
      const customClass = htmlClass || '';
      const attrId = htmlId ? ` id="${htmlId}"` : '';
      const attrHref = href ? ` href="${href}"` : '';
      return `
      <a class="menu__item ${classHidden} ${customClass}"${attrId}${attrHref}>
        <img class="menu__item-icon" src="${icon}" alt="" />
        <div class="menu__item-text">${text}</div>
      </a>
    `;
    });
    $menuList.innerHTML = template.join('');
  }
})();

(function initCheckbox() {
  onClickAll('.checkbox', (event) => {
    if (!(event.target.nodeName === 'A')) {
      event.currentTarget.classList.toggle('checkbox_checked');
    }
  });
})();

(function initBackBtn() {
  onClickAll('.behavior-go-back', () => {
    window.history.go(-1);
  });
})();

(function initBtnGoHome() {
  onClickAll('.behavior-go-home', () => {
    window.location.href = localStorage.getItem('home');
  });
})();

(function initBtnGoToCombos() {
  onClickAll('.behavior-go-combos', () => {
    redirectToPage.combos();
  });
})();
